import React from 'react';
import { Button } from '../ButtonElements';
import {
    InfoContainer,
    InfoWrapper,
    InfoRow,
    Column1,
    Column2,
    TextWrapper,
    TopLine,
    Heading,
    Subtitle,
    BtnWrap,
    ImgWrap,
    MediaBox,
    Img,
    MediaVideo,
    ListWrapper,
    ListItem,
    NumberedListWrapper,
    NumberedListItem
} from './InfoElements';

const InfoSection = ({
    lightBg,
    id,
    imgStart,
    topLine,
    lightText,
    headline,
    darkText,
    description,
    buttonLabel,
    img,
    alt,
    dark,
    dark2,
    primary,
    buttonLink,
    video,
    listItems,
    numberedListItems
}) => {
    const hasList = (listItems && listItems.length > 0) || (numberedListItems && numberedListItems.length > 0);

    return (
        <InfoContainer lightBg={lightBg} id={id}>
            <InfoWrapper>
                <InfoRow imgStart={imgStart}>
                    <Column1>
                        <TextWrapper>
                            <TopLine>{topLine}</TopLine>
                            <Heading lightText={lightText}>{headline}</Heading>
                            {hasList ? (
                                <>
                                    {numberedListItems && numberedListItems.length > 0 && (
                                        <NumberedListWrapper>
                                            {numberedListItems.map((item, i) => (
                                                <NumberedListItem key={i} darkText={darkText}>
                                                    {item}
                                                </NumberedListItem>
                                            ))}
                                        </NumberedListWrapper>
                                    )}
                                    {listItems && listItems.length > 0 && !numberedListItems && (
                                        <ListWrapper>
                                            {listItems.map((item, i) => (
                                                <ListItem key={i} darkText={darkText}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </ListWrapper>
                                    )}
                                </>
                            ) : (
                                description && <Subtitle darkText={darkText}>{description}</Subtitle>
                            )}
                            {buttonLabel && (
                                <BtnWrap>
                                    <Button
                                        to={buttonLink || 'home'}
                                        smooth={true}
                                        duration={500}
                                        spy={true}
                                        exact="true"
                                        offset={-80}
                                        primary={primary ? 1 : 0}
                                        dark={dark ? 1 : 0}
                                        dark2={dark2 ? 1 : 0}
                                    >
                                        {buttonLabel}
                                    </Button>
                                </BtnWrap>
                            )}
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                            <MediaBox>
                                {video ? (
                                    <MediaVideo
                                        src={video}
                                        autoPlay
                                        loop
                                        muted
                                        playsInline
                                        title={alt}
                                    />
                                ) : (
                                    img && <Img src={img} alt={alt} />
                                )}
                            </MediaBox>
                        </ImgWrap>
                    </Column2>
                </InfoRow>
            </InfoWrapper>
        </InfoContainer>
    );
};

export default InfoSection;
